"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebRouter = void 0;
const core_1 = require("@ts-rest/core");
const web_guest_cart_router_1 = require("./cart/web.guest-cart.router");
const web_orders_router_1 = require("./orders/web.orders.router");
const addresses_1 = require("./addresses");
const auth_1 = require("./auth");
const cart_1 = require("./cart");
const collections_1 = require("./collections");
const membership_1 = require("./membership");
const paypal_1 = require("./paypal");
const products_1 = require("./products");
const profile_1 = require("./profile");
const reviews_1 = require("./reviews");
const shippings_1 = require("./shippings");
const stores_1 = require("./stores");
const c = (0, core_1.initContract)();
exports.WebRouter = c.router({
    addresses: addresses_1.WebAddressesRouter,
    auth: auth_1.WebAuthRouter,
    cart: cart_1.WebCartRouter,
    guestCart: web_guest_cart_router_1.WebGuestCartRouter,
    collections: collections_1.WebCollectionsRouter,
    membership: membership_1.WebMembershipRouter,
    orders: web_orders_router_1.WebOrdersRouter,
    paypal: paypal_1.WebPaypalRouter,
    products: products_1.WebProductsRouter,
    profile: profile_1.WebProfileRouter,
    reviews: reviews_1.WebReviewsRouter,
    shippings: shippings_1.WebShippingsRouter,
    stores: stores_1.WebStoresRouter,
}, { pathPrefix: '/web' });
